// Localization is based on '@ngx-translate/core';
// Please be familiar with official documentations first => https://github.com/ngx-translate/core

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CustomizerService } from './customizer.service';

export interface Locale {
  lang: string;
  data: any;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];
  public layoutType: string = 'ltr'
  private _lanDir: BehaviorSubject<string> = new BehaviorSubject<string>('ltr')


  public get lanDir$() : Observable<string> {
    return this._lanDir.asObservable();
  }



  constructor(
    private translate: TranslateService,
    private customizer : CustomizerService,
    ) {
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];
    locales.forEach((locale) => {
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    this.translate.addLangs(this.langIds);
  }
  getTranslatedValue(key: string): string { 
    return this.translate.instant(key);
  }

  setLanguage(lang: string):any{
    try {
      if (lang) {
        localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
        if(lang ==='es'){
          this._lanDir.next('rtl');
          this.customizeLayoutType('rtl');
        } else {
          this._lanDir.next('ltr');
          this.customizeLayoutType('ltr');
        }
        return this.translate.use(lang);
      }
    }
    catch {
      return of(null);
    }
  }
  public changeLanguage(lang: string) {
    this.translate.use(lang);
    if (lang === 'es') {
      this.customizeLayoutType('rtl'); // Switch to RTL if Spanish is selected
    } else {
      this.customizeLayoutType('ltr'); // Switch to LTR for other languages
    }
  }
  customizeLayoutType(val:any) {
    this.customizer.setLayoutType(val)
    this.layoutType = val
  }
  removeLanguage() {
    try {
      localStorage.removeItem(LOCALIZATION_LOCAL_STORAGE_KEY);
    }
    catch {

    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    try {
      if (localStorage) {
        return  localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY)
      }
      return null;
    }
    catch {
      return null;
    }
  }

  getValue(key: string) {
    return this.translate.instant(key);
  }
}
